import type {
  ArticleWholesaleEvidence,
  PriceHistoryRow,
} from "../../api/articles";

export function wholesaleEvidenceToHistoryRow(
  row: ArticleWholesaleEvidence,
): PriceHistoryRow {
  return {
    doc_date: row.doc_date,
    doc_type: row.doc_type,
    doc_number: row.doc_number,
    line_pos: row.line_pos,
    project_key: null,
    project_exists: null,
    supplier: row.supplier,
    qty: row.qty,
    uom: row.uom,
    list_unit_price: row.list_unit_price,
    discount_pct: row.discount_pct,
    net_unit_price: row.net_unit_price,
    effective_unit_price: row.net_unit_price,
    line_net_amount: row.line_net_amount,
    baseline_kind: null,
    result: null,
    description: row.description,
    page_no: null,
    invoice_doc_id: null,
    online_user_email: null,
    online_user_name: null,
    delivery_address_key: null,
    delivery_address_display: null,
    delivery_is_warehouse: null,
    source_kind: row.source_kind,
    wholesale_file_id: row.wholesale_file_id,
    wholesale_source_record_row: row.wholesale_source_record_row,
    wholesale_source_file: row.wholesale_source_file,
    wholesale_raw_record: row.wholesale_raw_record,
  };
}
